import { Toast } from '@base-ui/react/toast';

import type { TNotifyOptions } from './notify.types';

const toastManager = Toast.createToastManager();

const show = (options: TNotifyOptions): void => {
  toastManager.add(options);
};

const notify = {
  show,
  success: (title: string): void => show({ title, type: 'success' }),
  error: (title: string): void => show({ title, type: 'error' }),
  info: (title: string): void => show({ title, type: 'info' }),
};

export {
  notify,
  toastManager,
};
